export default function PHP_gmstrftime() {
  return (
    <div>
      <h1>PHP_gmstrftime</h1>
    </div>
  );
}
